import { render, staticRenderFns } from "./message-text.vue?vue&type=template&id=d82f444a&scoped=true&"
import script from "./message-text.vue?vue&type=script&lang=ts&"
export * from "./message-text.vue?vue&type=script&lang=ts&"
import style0 from "./message-text.vue?vue&type=style&index=0&id=d82f444a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82f444a",
  null
  
)

export default component.exports